
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { TrendingUp } from 'lucide-react';

const StatusChart = ({ tickets, cardClasses, isDarkMode }) => {
  // Contar tickets por estado
  const statusCounts = tickets.reduce((acc, ticket) => {
    const estado = ticket.Estado_de_solicitud || 'Sin estado';
    acc[estado] = (acc[estado] || 0) + 1;
    return acc;
  }, {});

  const statusData = [
    { 
      name: 'Cerrado', 
      value: statusCounts['Cerrado'] || 0, 
      color: '#059669' 
    },
    { 
      name: 'Solucionado', 
      value: statusCounts['Solucionado'] || 0, 
      color: '#10B981' 
    },
    { 
      name: 'En curso', 
      value: statusCounts['En curso'] || 0, 
      color: '#3B82F6' 
    },
    { 
      name: 'Pendiente por usuario', 
      value: statusCounts['Pendiente por usuario'] || 0, 
      color: '#F59E0B' 
    },
    { 
      name: 'Cancelado', 
      value: statusCounts['Cancelado'] || 0, 
      color: '#EF4444' 
    },
  ].filter(item => item.value > 0);

  return (
    <div className={`${cardClasses} p-6 rounded-2xl`}>
      <h3 className="text-xl font-bold mb-6 flex items-center">
        <TrendingUp className="w-6 h-6 mr-2 text-blue-400" />
        Distribución por Estado
      </h3>
      
      {/* Contenedor principal con flex row */}
      <div className="flex items-center justify-between gap-8">
        {/* Leyenda a la izquierda */}
        <div className="flex flex-col space-y-3 min-w-0 flex-shrink-0">
          {statusData.map((item, index) => (
            <div key={index} className="flex items-center space-x-3">
              <div className="w-4 h-4 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }}></div>
              <span className="text-sm font-medium whitespace-nowrap">
                {item.name}: {item.value}
              </span>
            </div>
          ))}
        </div>
        
        {/* Gráfica a la derecha */}
        <div className="flex-1 min-w-0">
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie
                data={statusData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={100}
                paddingAngle={5}
                dataKey="value"
              >
                {statusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{
                  backgroundColor: isDarkMode ? '#1F2937' : 'white',
                  border: 'none',
                  borderRadius: '12px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                  color: isDarkMode ? '#F9FAFB' : '#1F2937'
                }}
                labelStyle={{
                  color: isDarkMode ? '#F9FAFB' : '#1F2937'
                }}
                itemStyle={{
                  color: isDarkMode ? '#F9FAFB' : '#1F2937'
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default StatusChart;